import React from 'react';
import { IMenuProps } from './MenuProps';

//We need an explicit "import '../styles'" to force import of mediaSize for styled-components, even though VSCode thinks it is never used
//See: https://github.com/microsoft/TypeScript/issues/9191
import '../styles';
import MenuIFR from './MenuIFR/MenuIFR';
import MenuLUXE from './MenuLUXE/MenuLUXE';
import MenuSimple from './MenuSimple/MenuSimple';
//--

interface Props {
	menuType:'ifr'|'luxe'|'simple'|'simpleLuxe',
	menuProps:IMenuProps
};

interface State {
};

export default class Menu extends React.Component<Props,State> {
  constructor(props) {
    super(props);
  };

  componentDidMount(): void {
	this.props.menuProps.setConfigId();
  }

  render() {
		const { menuType, menuProps } = this.props;
		let menu;

		if (menuType === 'luxe') {
			menu = <MenuLUXE
				{...menuProps}
			/>
		} else if(menuType === 'simple' || menuType === 'simpleLuxe'){
			menu = <MenuSimple menuProps={menuProps} menuType={menuType}/>
		}else { //Use IFR-style menu as default
			menu = <MenuIFR 
				{...menuProps}
			/>
		}

		return menu;
	}
};
